var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarHalfFilled = function SvgStarHalfFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M11.75 2c.966 0 1.75.784 1.75 1.75V10h6.25a1.75 1.75 0 1 1 0 3.5H13.5v6.25a1.75 1.75 0 1 1-3.5 0V13.5H3.75a1.75 1.75 0 1 1 0-3.5H10V3.75c0-.966.784-1.75 1.75-1.75",
    clipRule: "evenodd"
  })));
};
export default SvgStarHalfFilled;